<template>
  <div class="statistics">
    <div class="top" style="margin-bottom: 20px">
      <el-button type="primary" @click="goback">返回</el-button>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="轨迹截取" key="trail" name="trail" class="table">
        <div class="statisticsBox">
          <el-aside class="aside">
            <el-tabs v-model="locusActiveName" @tab-click="locusHandleClick">
              <el-tab-pane label="车辆轨迹" name="first">
                <!-- <el-row class="title">
                  <div class="grid-content bg-purple">车辆轨迹</div>
                </el-row> -->
                <el-row class="trailPath">
                  <el-row
                    class="trailPathItem"
                    :class="{ active: isActive == index }"
                    :key="item.id"
                    v-for="(item, index) in trailList"
                    @click.native="getTrailPoint(item.id, index)"
                  >
                    <el-row class="time">{{ item.addTime }}</el-row>
                    <el-row class="pathItem">
                      <span>轨迹来源：</span>
                      <span>{{ item.personnelName }}（{{ item.plate }}）</span>
                    </el-row>
                    <el-row class="pathItem">
                      <span>截取路径：</span>
                      <span>约{{ item.distance }}米</span>
                    </el-row>
                  </el-row>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="方案轨迹" name="second">
                <el-row class="trailPath">
                  <el-row
                    class="trailPathItem"
                    :class="{ active: isActive == index }"
                    :key="item.id"
                    v-for="(item, index) in planList"
                    @click.native="getTrailPoint(item.id, index)"
                  >
                    <el-row class="time">{{ item.addTime }}</el-row>
                    <el-row class="pathItem">
                      <span>轨迹来源：</span>
                      <span>{{ item.personnelName }}（{{ item.plate }}）</span>
                    </el-row>
                    <el-row class="pathItem">
                      <span>截取路径：</span>
                      <span>约{{ item.distance }}米</span>
                    </el-row>
                  </el-row>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-aside>
          <el-row class="main">
            <div id="mapBox" class="mapWrapper"></div>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="基站路径"
        key="basePath"
        name="basePath"
        class="table"
      >
        <div class="statisticsBox">
          <el-aside class="aside">
            <el-row class="title">
              <el-col :span="22" class="grid-content bg-purple"
                >基站路径列表</el-col
              >
              <el-col
                :span="2"
                style="color: #0094ff; cursor: pointer"
                @click.native="deletePath"
                ><i class="el-icon-delete"></i
              ></el-col>
            </el-row>
            <el-row class="trailPath">
              <el-row
                class="trailPathItem"
                :class="{ active: isActive == index }"
                v-for="(item, index) in stationPathList"
                :key="item.stationAddrId"
                @click.native="checkPathImg(item.stationAddrId, index)"
              >
                <el-row class="time">
                  {{ item.addTime }}
                  <span class="review" v-if="item.review == 3">未通过</span>
                </el-row>
                <el-row class="pathItem">
                  <span>轨迹来源：</span>
                  <span>{{ item.personnelName }}（{{ item.plate }}）</span>
                </el-row>
              </el-row>
            </el-row>
          </el-aside>
          <el-row class="main">
            <div class="imgList" v-if="pathImgList && pathImgList.length > 0">
              <el-row
                class="imgItem"
                @click.native="openImgWindow(item, index)"
                :class="{ active: isActiveImg == index }"
                v-for="(item, index) in pathImgList"
                :key="index"
              >
                <span class="sortIndex">{{ item.sort }}</span>
                <el-image
                  v-if="judgeImg(item.url)"
                  class="imgBox"
                  :src="item.url"
                  fit="cover"
                >
                </el-image>
                <template v-else>
                  <video
                    :src="item.url"
                    class="videoBox"
                    width="150"
                    height="110"
                  ></video>
                  <i class="iconfont iconshipinbofang"></i>
                </template>
              </el-row>
            </div>
            <div id="mapBoxTwo" class="mapWrapper"></div>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="油机发电口路径"
        key="oilPath"
        name="oilPath"
        class="table"
      >
        <div class="statisticsBox">
          <el-aside class="aside">
            <el-row class="title">
              <el-col :span="22" class="grid-content bg-purple"
                >油机发电口路径列表</el-col
              >
              <el-col
                :span="2"
                style="color: #0094ff; cursor: pointer"
                @click.native="deletePath"
                ><i class="el-icon-delete"></i
              ></el-col>
            </el-row>
            <el-row class="trailPath">
              <el-row
                class="trailPathItem"
                :class="{ active: isActive == index }"
                v-for="(item, index) in oilPathList"
                :key="item.stationAddrId"
                @click.native="checkPathImg(item.stationAddrId, index)"
              >
                <el-row class="time">
                  {{ item.addTime }}
                  <span class="review" v-if="item.review == 3">未通过</span>
                </el-row>
                <el-row class="pathItem">
                  <span>轨迹来源：</span>
                  <span>{{ item.personnelName }}（{{ item.plate }}）</span>
                </el-row>
              </el-row>
            </el-row>
          </el-aside>
          <el-row class="main">
            <div class="imgList" v-if="pathImgList && pathImgList.length > 0">
              <el-row
                class="imgItem"
                @click.native="openImgWindow(item, index)"
                :class="{ active: isActiveImg == index }"
                v-for="(item, index) in pathImgList"
                :key="index"
              >
                <span class="sortIndex">{{ item.sort }}</span>
                <el-image
                  v-if="judgeImg(item.url)"
                  class="imgBox"
                  :src="item.url"
                  fit="cover"
                >
                </el-image>
                <template v-else>
                  <video
                    :src="item.url"
                    class="videoBox"
                    width="150"
                    height="110"
                  ></video>
                  <i class="iconfont iconshipinbofang"></i>
                </template>
              </el-row>
            </div>
            <div id="mapBoxThree" class="mapWrapper"></div>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-row class="infoWindow" ref="pathInfowindow" v-show="pathId">
      <el-row class="imgBox" style="width: 150px; height: 110px" v-if="isImg">
        <el-image :src="pathInfowindowData.url" :preview-src-list="previewArr">
        </el-image>
      </el-row>
      <el-row class="videoBox" v-else @click.native="openVideo">
        <video
          ref="videoPlayer"
          preload
          width="150"
          height="110"
          :src="pathInfowindowData.url"
        ></video>
        <i class="iconfont iconshipinbofang"></i>
      </el-row>
      <el-row class="desc">{{ pathInfowindowData.remark }}</el-row>
    </el-row>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      class="videoDialog"
      width="0px"
    >
      <video
        height="750"
        fit="cover"
        controls
        autoplay
        duration
        paused
        ref="videoPlayerBig"
        id="videoPlayerBig"
        :src="pathInfowindowData.url"
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import AMap from "AMap";
export default {
  name: "BaseStationPath",
  props: {
    code: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      dialogVisible: false,
      //   code:null,
      isImg: true,
      switch: true,
      pathSwitch: true,
      pathInfowindow: null, // 基站信息窗体
      pathInfowindowData: {},
      previewArr: [],
      pathId: false,
      isActive: 0,
      isActiveImg: 0,
      deletePathId: null,
      activeName: "trail",
      oilPathList: [],
      stationPathList: [],
      pathImgList: [],
      trailList: [],
      points: [],
      routeLine: null,
      bsMarker: null,
      startMarker: null,
      endMarker: null,
      map: null,
      scale: null,
      pathMarker: null,
      pathIcon: null,
      locusActiveName: "first",
      planList: [],
    };
  },
  //   created() {
  //      this.code=this.$route.params.code || sessionStorage.getItem("code")
  //      sessionStorage.setItem("code",this.code)
  //  },
  mounted() {
    this.$nextTick(() => {
      this.init("mapBox");
    });
    this.getTrailList();
    this.getStationLocal();
  },
  methods: {
    openVideo() {
      this.dialogVisible = true;
    },
    goback() {
      // this.$router.push('/BaseStation')
      this.$emit("goback");
    },
    judgeImg(url) {
      let str = url.split(".").pop();
      console.log(str);
      if (str == "mp4") {
        return false;
      } else {
        return true;
      }
    },
    //   查询轨迹截取列表
    async getTrailList() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/base/station/addr/traces/" + _this.code
      );
      if (res.code == 1) {
        this.trailList = res.data;
        if (this.trailList && this.trailList.length > 0) {
          this.getTrailPoint(this.trailList[0].id, 0);
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //   查询方案轨迹截取列表
    async getPlanList() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/base/station/addr/traces/scheme/" + _this.code
      );
      if (res.code == 1) {
        this.planList = res.data;
        if (this.planList && this.planList.length > 0) {
          this.getTrailPoint(this.planList[0].id, 0);
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 查看基站定位
    async getStationLocal() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/base/station/gps/location?code=" + _this.code
      );
      if (res.code == 1) {
        if (_this.bsMarker) {
          _this.map.remove(_this.bsMarker);
        }
        _this.bsMarker = new AMap.Marker({
          icon: require("@/assets/images/base-station.png"),
          anchor: "bottom-center",
          position: [res.data.longitude, res.data.latitude],
          offset: new AMap.Pixel(0, 5), // 设置点标记偏移量
        });
        _this.map.add(_this.bsMarker);
        // _this.map.setCenter([res.data.longitude,res.data.latitude])
        _this.bsMarker.on("click", function () {
          var info = [];
          info.push("<p class='input-item'>" + res.data.name + "</p>");
          _this.infoWindow = new AMap.InfoWindow({
            offset: new AMap.Pixel(0, -40),
            //   position:[res.data.longitude,res.data.latitude],
            anchor: "bottom-center",
            closeWhenClickMap: true,
            //   autoMove:true,
            content: info.join(""), //使用默认信息窗体框样式，显示信息内容
          });
          if (_this.switch) {
            _this.infoWindow.open(_this.map, [
              res.data.longitude,
              res.data.latitude,
            ]);
          } else {
            _this.infoWindow.close();
          }
          _this.switch = !_this.switch;
          // _this.infoWindow.open(_this.map,[res.data.longitude,res.data.latitude])
        });
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 获取轨迹路径
    async getTrailPoint(id, index) {
      this.isActive = index;
      this.map.clearMap();
      this.getStationLocal();
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/base/station/addr/trace/" + id
      );
      if (res.code == 1) {
        this.points = res.data.track.points;
        this.routeLine = new AMap.Polyline({
          map: _this.map,
          path: _this.points,
          isOutline: false,
          strokeWeight: 5,
          strokeColor: "#0094FF",
          showDir: true,
          lineJoin: "round",
        });
        this.startIcon = new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(25, 34),
          // 图标的取图地址
          image:
            "//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png",
          // 图标所用图片大小
          imageSize: new AMap.Size(135, 40),
          // 图标取图偏移量
          imageOffset: new AMap.Pixel(-9, -3),
        });
        this.endIcon = new AMap.Icon({
          size: new AMap.Size(25, 34),
          image:
            "//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png",
          imageSize: new AMap.Size(135, 40),
          imageOffset: new AMap.Pixel(-95, -3),
        });
        this.startMarker = new AMap.Marker({
          zIndex: 200,
          icon: _this.startIcon,
          anchor: "bottom-center",
          position: res.data.track.startPoint, // 基点位置
          offset: new AMap.Pixel(0, 5), // 设置点标记偏移量
        });
        this.endMarker = new AMap.Marker({
          zIndex: 200,
          icon: _this.endIcon,
          anchor: "bottom-center",
          position: res.data.track.endPoint, // 基点位置
          offset: new AMap.Pixel(0, 5), // 设置点标记偏移量
          map: this.map,
        });
        this.map.add(this.startMarker);
        this.map.add(this.endMarker);
        this.map.setCenter(res.data.track.startPoint);
        this.map.setZoom(16);
        this.routeLine.setMap(this.map);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 查询站址路径列表
    async getStationPathList(type) {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/base/station/addr?code=" + _this.code + "&type=" + type
      );
      if (res.code == 1) {
        if (this.activeName == "basePath") {
          this.stationPathList = res.data;
        }
        if (this.activeName == "oilPath") {
          this.oilPathList = res.data;
        }
        if (res.data.length > 0) {
          this.checkPathImg(res.data[0].stationAddrId, 0);
          this.deletePathId = res.data[0].stationAddrId;
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 查看站址路径的图片信息
    async checkPathImg(id, index) {
      this.isActive = index;
      this.deletePathId = id;
      this.map.clearMap();
      this.getStationLocal();
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/base/station/addr/scheme/" + id
      );
      if (res.code == 1) {
        this.pathImgList = res.data.addrImages;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 点击站址路径图片，定位到地图上
    openImgWindow(data, index) {
      if (this.pathMarker) {
        this.map.remove(this.pathMarker);
      }
      this.pathSwitch = true;
      this.$nextTick(() => {
        let _this = this;
        this.isActiveImg = index;
        this.previewArr = [];
        this.pathId = true;
        this.previewArr.push(data.url);
        let str = data.url.split(".").pop();
        if (str == "mp4") {
          this.isImg = false;
        } else {
          this.isImg = true;
        }
        this.pathInfowindowData = data;
        this.pathMarker = new AMap.Marker({
          zIndex: 190,
          icon: _this.pathIcon,
          anchor: "bottom-center",
          position: [data.longitude, data.latitude], // 基点位置
          offset: new AMap.Pixel(0, 5), // 设置点标记偏移量
          map: _this.map,
        });
        this.map.add(this.pathMarker);
        this.pathInfowindow.open(this.map, [data.longitude, data.latitude]);
        this.map.setCenter([data.longitude, data.latitude]);
        this.map.setZoom(20);
        this.pathMarker.on("click", function () {
          _this.pathSwitch = !_this.pathSwitch;
          if (_this.pathSwitch) {
            _this.pathInfowindow.open(_this.map, [
              data.longitude,
              data.latitude,
            ]);
          } else {
            _this.pathInfowindow.close();
          }
        });
      });
    },
    // 删除路径
    deletePath() {
      this.$confirm("确认删除？")
        .then(() => {
          this.confirmPath();
        })
        .catch(() => {});
    },
    async confirmPath() {
      let _this = this;
      let { data: res } = await _this.$axios.delete(
        "/api/base/station/addr/" + _this.deletePathId
      );
      if (res.code == 1) {
        this.$message.success("删除成功");
        this.pathImgList = [];
        if (this.activeName == "basePath") {
          this.init("mapBoxTwo");
          this.getStationPathList(1);
        }
        if (this.activeName == "oilPath") {
          this.init("mapBoxThree");
          this.getStationPathList(2);
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    handleClick() {
      this.pathImgList = [];
      this.switch = true;
      this.isActiveImg = 0;
      if (this.activeName == "trail") {
        this.locusActiveName = "first";
        this.init("mapBox");
        this.getStationLocal();
        this.getTrailList();
        this.getTrailPoint(this.trailList[0].id, 0);
      }
      if (this.activeName == "basePath") {
        this.init("mapBoxTwo");
        this.getStationLocal();
        this.getStationPathList(1);
      }
      if (this.activeName == "oilPath") {
        this.init("mapBoxThree");
        this.getStationLocal();
        this.getStationPathList(2);
      }
    },
    locusHandleClick() {
      this.switch = true;
      if (this.locusActiveName == "first") {
        this.init("mapBox");
        this.getStationLocal();
        this.getTrailList();
        this.getTrailPoint(this.trailList[0].id, 0);
      }
      if (this.locusActiveName == "second") {
        this.init("mapBox");
        this.getStationLocal();
        this.getPlanList();
        this.getTrailPoint(this.planList[0].id, 0);
      }
    },
    init(id) {
      let _this = this;
      this.map = new AMap.Map(id, {
        resizeEnable: true,
        zoom: 11,
        mapStyle: "amap://styles/fresh",
      });
      this.pathInfowindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: _this.$refs.pathInfowindow.$el,
        offset: new AMap.Pixel(2, -30),
        anchor: "bottom-center",
        // closeWhenClickMap:true,
        autoMove: true,
      });
      this.pathIcon = new AMap.Icon({
        size: new AMap.Size(25, 34),
        image:
          "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png",
        imageSize: new AMap.Size(25, 34),
        map: _this.map,
      });
      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(this.scale);
      });
    },
  },
  //   beforeDestroy(){
  //         sessionStorage.removeItem("code")
  //     }
};
</script>

<style lang="scss" scoped>
.videoDialog {
  /deep/ .el-dialog {
    margin-top: 100px !important;
    .el-dialog__body {
      padding: 0px !important;
      #videoPlayerBig {
        max-width: 1000px;
        position: fixed;
        left: 0px;
        right: 0px;
        top: 0px;
        bottom: 0px;
        margin: auto;
      }
    }
  }
}
/deep/ .el-image-viewer__img {
  max-width: 100% !important;
  max-height: 100% !important;
}
.el-tabs {
  height: calc(100% - 55px);
  /deep/ .el-tabs__content {
    height: calc(100% - 40px);
    overflow: auto;
    .el-tab-pane {
      height: 100%;
    }
  }
}
.el-tabs /deep/ .el-tabs__header {
  background: #fff;
  margin-bottom: 20px;
  padding: 0 20px;
}
.el-tabs /deep/ #tab-0 {
  padding: 0;
  height: 0;
}

.statistics {
  margin: 20px;
  height: calc(100% - 25px);
  background-color: #f8f8f8;
  .statisticsBox {
    width: 100%;
    height: 100%;
    .aside {
      width: 280px;
      height: calc(100% - 10px);
      background: #fff;
      float: left;
      .trailPath {
        width: 100%;
        padding: 0 10px;
        .trailPathItem {
          // height: 112px;
          background: #ffffff;
          border: 1px solid #cccccc;
          border-radius: 6px;
          padding: 15px;
          cursor: pointer;
          margin-bottom: 10px !important;
          .time {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
            line-height: 25px;
            position: relative;
            .review {
              position: absolute;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #f91f1f;
              right: 10px;
            }
          }
          .pathItem {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 25px;
          }
        }
        .active {
          border: 2px solid #0094ff;
          border-radius: 6px;
        }
      }
    }
    .main {
      width: calc(100% - 320px);
      height: calc(100% - 10px);
      background: #fff;
      padding: 1px;
      float: left;
      position: relative;
      .imgList {
        position: absolute;
        box-sizing: border-box;
        width: 170px;
        height: calc(100% - 30px);
        overflow: auto;
        background: #ffffff;
        padding: 10px 20px;
        z-index: 70;
        left: 15px;
        top: 15px;
        .imgItem {
          width: 130px;
          height: 110px;
          margin: 10px 0 !important;
          position: relative;
          cursor: pointer;
          .sortIndex {
            position: absolute;
            left: 5px;
            top: 5px;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background: #fff;
            border-radius: 50%;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            z-index: 99;
          }
          .imgBox {
            width: 100%;
            height: 100%;
          }
          i {
            position: absolute;
            font-size: 35px;
            left: 46px;
            top: 36px;
            color: #fff;
          }
          i:hover {
            color: #fff;
          }
          .videoBox {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .active {
          border: 1px solid #0094ff;
        }
      }
      .mapWrapper {
        height: 100%;
        width: 100%;
      }
    }
    // background: #fff;
  }
  .infoWindow {
    width: 170px;
    background: #ffffff;
    border: 1px solid #999999;
    border-radius: 8px;
    padding: 5px;
    position: relative;
    cursor: pointer;
    .imgBox {
      width: 158px;
      height: 110px;
      .el-image {
        width: 158px;
        height: 110px;
      }
    }
    .videoBox {
      position: relative;
      width: 158px;
      height: 110px;
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .iconshipinbofang {
        position: absolute;
        font-size: 35px;
        left: 54px;
        top: 34px;
        color: #fff;
      }
      .iconshipinbofang:hover {
        color: #fff;
      }
    }
    .desc {
      word-wrap: break-word;
      font-size: 14px;
      line-height: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
  }
  .infoWindow:before {
    box-sizing: content-box;
    width: 0px;
    height: 0px;
    position: absolute;
    bottom: -16px;
    right: 80px;
    padding: 0;
    border-top: 8px solid #ffffff;
    border-bottom: 8px solid transparent;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    display: block;
    content: "";
    z-index: 12;
  }
  .infoWindow:after {
    box-sizing: content-box;
    width: 0px;
    height: 0px;
    position: absolute;
    bottom: -18px;
    right: 80px;
    padding: 0;
    border-top: 9px solid #999;
    border-bottom: 9px solid transparent;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    display: block;
    content: "";
    z-index: 10;
  }
}
//地图
#map-box {
  display: inline-block;
  width: calc(100% - 240px);
  height: 100%;
}
.group-box {
  width: 100%;
  height: calc(100% - 42px);
  flex-direction: row;
  display: flex;
  padding: 0 10px 10px 0;
  box-sizing: border-box;
}
.show-station {
  width: 100px;
  margin: 0 0 10px 20px;
}
#map-box /deep/ .amap-info-content {
  padding: 10px 25px;
  border: 1px solid #ccc;
  border-radius: 6px;
  line-height: 20px;
  font-size: 14px;
  color: #333;
}
.imgList::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.imgList::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.7);
  background: #999;
}
.imgList::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.7);
  border-radius: 2px;
  background: #ededed;
}
</style>
